export default "__VITE_ASSET__DfpHw_fD__"